import axios from "axios";
import config from "configs/config";

//axios instance
const apiClient = axios.create({
  baseURL: config.baseUrl, //setting up the golobally to this base URL
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const token = userData?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers["ProjectDetail"] = "Vision";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const errorMessage = error.response.data?.message;
      if (errorMessage === "jwt expired" || errorMessage === "Invalid AccessToken") {
        localStorage.clear();
          window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
